module.exports = __webpack_public_path__ + "assets/lawandorder-5.551cd729.svg";